import { Component, OnInit } from '@angular/core';
import {PaginationArgs} from '../shared/models/pagination.args';
import {FeedbackService} from '../shared/services/feedback.service';
import {FeedbackWebDto} from '../shared/models/feedback.web.dto';
import {LazyLoadEvent} from 'primeng/api';
import {ContactUsService} from '../shared/services/contact.us.service';
import {ContactUsWebDtoModel} from '../shared/models/contact.us.web.dto.model';

@Component({
  selector: 'njoy-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  public paginationArgs: PaginationArgs = {pageNumber: 0, pageSize: 10};

  public listContactUs = [];
  public totalRecords = 0;
  public first = 0;
  public row = 0;

  constructor(private contactUsService: ContactUsService) {
  }

  ngOnInit(): void {
    this.row = 10;
    this.paginationArgs = {pageNumber: 0, pageSize: this.row};
    this.getAllContactUsMessage();
  }

  private getAllContactUsMessage() {
    this.contactUsService.findContactUsByPage(this.paginationArgs).subscribe((data: any) => {
      this.listContactUs = data.content;
      this.listContactUs.forEach((item: ContactUsWebDtoModel) => {
        item.creationDate = new Date(item.creationDate);
      });
      this.totalRecords = data.totalElements;
      this.row = this.paginationArgs.pageSize;
    });
  }

  public onLazyLoad(event: LazyLoadEvent) {
    this.paginationArgs = {pageNumber: event.first / event.rows, pageSize: event.rows};
    this.getAllContactUsMessage();
  }
}
